import PropTypes from "prop-types";
import { Box, Stack, SvgIcon, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faStar } from "@fortawesome/pro-solid-svg-icons";

export const FavouriteHeader = ({ isNewFavourite, existingFavourite }) => {
  const { t } = useTranslation();

  return (
    <Box sx={{ px: 3, py: 2.5, bgcolor: "background.default" }}>
      <Stack direction="row" spacing={1} sx={{
        alignItems: "center"
      }}>
        <SvgIcon fontSize="small" color="primary">
          <FontAwesomeIcon icon={faStar} />
        </SvgIcon>
        <Typography variant="h6" sx={{
          fontWeight: 600
        }}>
          {!isNewFavourite && existingFavourite
            ? t("favourites.editFavourite")
            : t("favourites.favouriteAdded")}
        </Typography>
      </Stack>
    </Box>
  );
};

FavouriteHeader.propTypes = {
  isNewFavourite: PropTypes.bool,
  existingFavourite: PropTypes.object,
};
